import React, { memo } from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  text: 'Por fin algo que no te marea con reglas. Empecé a usar frases desde la primera semana y ya me siento más seguro.',
  name: 'María L.',
  age: 34,
  city: 'Córdoba'
}, {
  text: 'Siempre empezaba cursos y los dejaba. Con el planner de 30 días logré ser constante por primera vez.',
  name: 'Carlos R.',
  age: 42,
  city: 'Rosario'
}, {
  text: 'Me encantó aprender con las canciones. Es la forma más fácil de memorizar sin aburrirte.',
  name: 'Luciana G.',
  age: 29,
  city: 'Buenos Aires'
}, {
  text: 'Trabajo todo el día y solo tengo 15 minutos. Este pack está perfecto para eso.',
  name: 'Diego M.',
  age: 38,
  city: 'Mendoza'
}, {
  text: 'Las historias cortas me ayudaron mucho con el reading. Ya entiendo textos que antes me parecían imposibles.',
  name: 'Valentina S.',
  age: 45,
  city: 'La Plata'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-[#F8F9FA] py-8 md:py-14 px-4" data-id="element-156">
      <div className="max-w-3xl mx-auto" data-id="element-157">
        <h2 className="text-2xl md:text-4xl font-bold text-[#1A1A2E] text-center mb-6" data-id="element-158">
          Lo que dicen los estudiantes:
        </h2>

        <div className="space-y-3" data-id="element-159">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-5 rounded-xl shadow-sm" data-id="element-160">
              <div className="flex gap-1 mb-3" data-id="element-161">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-162" />)}
              </div>
              <p className="text-[#4A4A5A] mb-4 italic" data-id="element-163">"{testimonial.text}"</p>
              <p className="text-sm font-semibold text-[#1A1A2E]" data-id="element-164">
                — {testimonial.name}, {testimonial.age} años, {testimonial.city}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}